export default __webpack_public_path__ + "static/media/Schoolchildren-hill-Thimpu-Bhutan.0e846e43.jpg";